import get from "lodash.get";
import styled from "styled-components";
export const NotificationStyled = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 5px;
  position: relative;
  transition: 0.2s ease all;
  cursor: pointer;

  #enableAudio {
    position: absolute;
    top: -200%;
    left: -200%;
    background: transparent;
    border: none;
  }

  .notification-container {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .notification-count {
      position: absolute;
      top: 0px;
      right: -7px;
      background: ${({ theme }) => get(theme, "error.main")};
      color: ${({ theme }) => get(theme, "white.main")};
      box-sizing: border-box;
      border-radius: 50%;
      font-size: 9px;
      font-weight: 600;
      width: 22px;
      height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 11px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
    }
  }
  .notification-menu {
    border-radius: 4px;
    transition: all 0.03s ease-in-out;
    width: 300px;
    box-shadow: ${({ theme }) => get(theme, "black.main")} 0px 10px 50px;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    background: ${({ theme }) => get(theme, "white.main")};
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => get(theme, "secondary.light")};
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => get(theme, "secondary.medium")};
      border-radius: 0 !important;
      opacity: 0.5;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => get(theme, "secondary.medium")};
      transform: scale(1.2);
      opacity: 1;
    }

    .notification-menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: fit-content;
      padding: 10px;
      border-bottom: 1px solid ${({ theme }) => get(theme, "secondary.medium")};
      .notification-menu-header-text {
        margin-bottom: 0;
        font-weight: 600;
      }
    }
    .infinite-scroll-component__outerdiv {
      .infinite-scroll-component {
        overflow: hidden !important;
        height: 100% !important;
      }
    }
  }
  .notification-menu.open {
    display: block;
  }
  .notification-menu.close {
    display: none;
  }
`;
